module.exports = __webpack_public_path__ + "static/img/jingpai.3ade8e49.jpg";